export const convertBufferToNumber = (value: Uint8Array): number => {
    return Number(new TextDecoder().decode(new Uint8Array(Object.values(value)))) || 0;
}
